<ui-header
  [primaryMenu]="primaryMenu"
  [primaryMenuMobile]="primaryMenuMobile"
  [secondaryMenu]="secondaryMenu"
  [isSecondMenuVisibile]="isSecondMenuVisible && !isLoginCambioPassword"
  [isBackMenuVisibile]="isBackMenuVisible || isLottomatica"
  [isLogged]="isLogged"
  [backMenuLink]="pathBackHeader"
  [backMenuLabel]="labelBackLinkHome | translate"
  [closeMenuMobile]="closeMenuMobile"
  [stopNavigate]="isActiveCloseBoxWorkflow"
  [showNotificationBanner]="showNotificationBanner"
  [notificationBannerText]="notificationBannerText"
  [showIconBacheca]="showIconBacheca"
  (clickItemMenu)="navigation($event, true)"
  (resetToggleMenuMobile)="resetToggleMenuMobile($event)"
>
  <ng-container sidebar>
    <ui-sidebar
      [sidebarVoices]="sidebarVoices"
      (clickItemSidebar)="navigation($event, true)"
    ></ui-sidebar>
  </ng-container>
</ui-header>

<router-outlet></router-outlet>
<div [class.mobile-footer]="isMobile">
  <ui-footer
  [labelLeft]="'Poste Italiane'"
    [linkFooter]="footerLink"
    [version]="version$ | async"
    (clickFooterLink)="navigation($event)"
  ></ui-footer>
</div>


<ui-modal [templateModal]="templateModal" [isOpenModal]="isModalVisible">
  <div body>
    <span class="font-bold mb-5">{{ 'MODAL:paragraph--returned-without-box-title' | translate }}</span>
    <p>{{ 'MODAL:paragraph--returned-without-box-description' | translate }}</p>
  </div>
  <div footer>
    <div class="mx-10 mb-4 flex">
      @if (!isExpiredObjectsBeforeToday) {
        <ui-button
          class="modal__custom-button mr-2.5"
          [label]="'BUTTON:later' | translate | uppercase"
          [buttonType]="buttonType.OUTLINE"
          [isRounded]="true"
          (click)="postponeModal()"
        ></ui-button>
      }
      <ui-button
        class="modal__custom-button-active"
        [label]="'BUTTON:close-box-active' | translate | uppercase"
        [buttonType]="buttonType.PRIMARY"
        [isRounded]="true"
        (click)="wizardBoxless()"
      ></ui-button>
    </div>
  </div>
</ui-modal>

<ui-loader></ui-loader>

<!--ALERT MODAL-->
@if(openAlertModal){
<ui-warning-modal
  [openWarningModal]="openAlertModal"
  (closeWarningModal)="closeModal($event)"
></ui-warning-modal>
}

<!-- MODALE DI TIPO ERROR -->
<ui-modal
  [templateModal]="templateModalEnum.ERROR"
  [isOpenModal]="interceptor.showModalError"
  [showCloseModalButton]="true"
  (closeModalEvent)="closeInterceptor()"
>
  <ng-container body>
    <p class="font-bold mb-5">{{ interceptor.errorModal?.header }}</p>
    <p>{{ interceptor.errorModal?.body }}</p>
    @if(interceptor.errorModal?.footer){
    <p>{{ interceptor.errorModal?.footer }}</p>
    }
  </ng-container>
  <ng-container footer>
    <div class="mx-10 mb-4 flex justify-center">
      <ui-button
        class="modal__custom-button"
        [label]="'BUTTON:close' | translate | uppercase"
        [buttonType]="buttonType.OUTLINE"
        [isRounded]="true"
        (click)="closeInterceptor()"
      ></ui-button>
    </div>
  </ng-container>
</ui-modal>
